export default "__VITE_ASSET__59895652__"